import AdminDeleteButton from '../../common/AdminDeleteButton';
import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const EventList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { events, total, page } = data;

    return (
        <>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Event Name</th>
                            <th>Category</th>
                            <th>Color</th>
                            <th>Status</th>
                            <th>Modified By</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {events?.length > 0 ? (
                            events.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span className="avatar-title rounded-circle bg-light text-primary">
                                                {item.NAME?.charAt(0).toUpperCase()}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{item.NAME}</td>
                                    <td>{item.CATEGORY_NAME || '-'}</td>
                                    <td>
                                        <span
                                            className="badge"
                                            style={{
                                                backgroundColor: item.COLOR_CODE,
                                                color: '#fff'
                                            }}
                                        >
                                            {item.COLOR_CODE}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            className={`badge rounded-pill ${item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'}`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{item.MODIFIED_BY_NAME || '-'}</td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item px-2">
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.editCategoryEventMasterData.url,
                                                        state: {
                                                            data: btoa(JSON.stringify(item)),
                                                            page: page,
                                                        },
                                                    }}
                                                    title="Edit Event"
                                                >
                                                    <i className="bx bx-edit"></i>
                                                </Link>
                                            </li>
                                            <li className="list-inline-item px-2">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => onChangeVisibility(item)}
                                                    style={{ color: "red" }}
                                                    title={item.IS_ACTIVE ? "Delete Event" : "Restore Event"}
                                                >
                                                    <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                </a>
                                            </li>
                                        <li className="list-inline-item px-2"><AdminDeleteButton resource="eventType" entryId={item.ID} label="eventType" /></li>
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">No Events found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </>
    );
};

export default withRouter(EventList);
